export default __webpack_public_path__ + "static/media/editbtn.bbc40ded.svg";